import React, { FC } from 'react';
import { IconProps } from '.';

export const InboxIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg
            fill="none"
            stroke="currentColor"
            {...sizing}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                strokeWidth="1.5"
                d="M4.22 8.75h15.56c.78 0 1.47.67 1.47 1.58v9.34c0 .9-.7 1.58-1.47 1.58H4.22c-.78 0-1.47-.67-1.47-1.58v-9.34c0-.9.7-1.58 1.47-1.58Z"
            />
            <path stroke="url(#8db89d1e)" d="M5.5 18.72V12c0-.28.22-.5.5-.5m12.34.13c.1.1.16.23.16.37v6.72" />
            <path d="M5.5 11.93c0-.24.2-.43.46-.43.13 0 .26.05.34.14l4.34 4.31a1.96 1.96 0 0 0 2.72 0l4.34-4.31a.49.49 0 0 1 .65-.02c.1.08.15.2.15.31M20 7.5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1M18.5 5.5a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1" />
            <defs>
                <linearGradient id="8db89d1e" x1="14" x2="14" y1="12.6" y2="18.6" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
